import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LIMIT } from 'data/global';
import { NavigationVariants } from 'models/Navigation';
import SingleSelectDropdownFilter from 'components/SingleSelectDropdownFilter';

import './NumberOfResultsPerPageFilter.styles.scss';

export const PER_PAGE = {
  25: '25',
  [DEFAULT_LIMIT]: DEFAULT_LIMIT,
  75: '75',
  100: '100',
  250: '250',
} as const;

type NumberOfResultsPerPageFilterProps = {
  className?: string;
  variant?: NavigationVariants;
  limit: string;
  updateLimit: (limit: string) => void;
};

const NumberOfResultsPerPageFilter: React.FC<
  NumberOfResultsPerPageFilterProps
> = (props) => {
  const { className, variant, limit, updateLimit } = props;

  const classes = classNames('number-of-results-per-page-filter', className);

  const { t } = useTranslation();

  return (
    <SingleSelectDropdownFilter
      className={classes}
      variant={variant}
      selectedValue={limit}
      triggerTitle={t('perPage', { count: +limit })}
      options={Object.entries(PER_PAGE).map(([key, value]) => ({
        value,
        label: t(key),
      }))}
      onChange={updateLimit}
    />
  );
};

export default NumberOfResultsPerPageFilter;
